import { Currency, ExchangeType, UnitOfMeasure } from '../../Generated/Raven-Demeter';

const tutorialUriBaseUrl = 'https://stonex.wistia.com/';
const tutorialUriMediaPrefix = `${tutorialUriBaseUrl}medias/`;

const applicationConstants = {
    ActingDemeterCompanyHeader: 'Company',
    AvailableExchanges: [
        ExchangeType.Cme,
        ExchangeType.Eex,
        ExchangeType.Euronext,
        ExchangeType.Dce,
        ExchangeType.Ice,
        ExchangeType.Sgx,
        ExchangeType.B3,
        ExchangeType.Otc,
    ] as ExchangeType[],
    AvailableEnergyExchanges: [ExchangeType.Cme, ExchangeType.Eex, ExchangeType.Euronext, ExchangeType.Ice],
    AvailableGeneralUnitOfMeasures: [
        UnitOfMeasure.HundredWeight,
        UnitOfMeasure.Kilogram,
        UnitOfMeasure.Liter,
        UnitOfMeasure.MetricTon,
        UnitOfMeasure.Pound,
        UnitOfMeasure.ShortTon,
    ],
    AvailableEnergyUnitOfMeasures: [UnitOfMeasure.Gallon, UnitOfMeasure.Barrel, UnitOfMeasure.MegaWattHour, UnitOfMeasure.MillionBritishThermalUnits],
    AvailableCurrencies: [Currency.Brl, Currency.Cad, Currency.Cop, Currency.Eur, Currency.Gbp, Currency.Nzd, Currency.Usd],
    // TODO: This will be removed.
    ChartExportOptionsDimensions: {
        MinHeight: 600,
        Height: 800,
        Width: 1200,
        Scale: 2,
        AdjustFactor: 0.67,
        AdjustFactorSeasonal: 0.72,
    },
    HttpStatus: {
        BadRequest: 400,
        Unauthorized: 401,
        Forbidden: 403,
        Conflict: 409,
    },
    DefaultDisplayDecimalPlacesMaximum: 4,
    DefaultDisplayDecimalPlacesMinimum: 0,
    ItemsPerPage: 20,
    // We only have one article sidebar label in development, therefore, we will use '5996' to test.
    MarketIntelligenceSidebarLabelDevelopment: '5996',
    MaximumTake: 10000,
    TutorialLinks: {
        catalog: `${tutorialUriBaseUrl}folders/p3qmzyj37v`,
        basisCalculator: `${tutorialUriMediaPrefix}iqln6id8kx`,
        forwardSpreadCalculator: `${tutorialUriMediaPrefix}i9o0t53qz6`,
        federalMilkCalculator: `${tutorialUriMediaPrefix}0zpod9xfxt`,
        riskCalculator: `${tutorialUriMediaPrefix}5o3tm8koll`,
        loggingIn: `${tutorialUriMediaPrefix}t3z07zxa74`,
        dashboard: `${tutorialUriMediaPrefix}kimg1vgyzq`,
        fundamentalsSupplyDemand: `${tutorialUriMediaPrefix}z792eb3kvw`,
        specialFeatures: `${tutorialUriMediaPrefix}586ablqmku`,
        valorization: `${tutorialUriMediaPrefix}pw42yrx94m`,
    },
    MenuSettingsTopLevelKey: 'topMenuType',
    MenuSettingsUserAlreadyAcknowledged: 'userAcknowledged',
    MenuSettingsUserHasSetCommodities: 'userHasSetCommodities',
    MenuSettingsSelectedCommoditiesKey: 'availableCommodities',
    SessionRefreshTimeInMinutes: 10,
    SessionTokenHeader: 'Session-Token',
    TablePlaceholderZeroOrEmpty: '--',
    ZeroGuid: '00000000-0000-0000-0000-000000000000',
};

export default applicationConstants;
